import {Component, Input, OnInit} from '@angular/core';
import {HttpService} from '../../../../services/http.service';
import {HttpErrorResponse} from '@angular/common/http';
import {composeMessage} from '../../consts/errors';
import {NotificationsService} from '../../services/notifications.service';

interface IWidgetData {
    content: string
}

@Component({
    selector: 'ageops-dynamic-widget',
    templateUrl: './dynamic-widget.component.html',
    styleUrls: ['./dynamic-widget.component.styl']
})

export class DynamicWidgetComponent implements OnInit {

    @Input('slug') slug: string;

    isLoading = true;
    data: IWidgetData = undefined;

    constructor(private httpService: HttpService,
                public notificationsService: NotificationsService) {
    }

    ngOnInit() {
        this.isLoading = true;
        this.httpService.get(`api/system-configuration/widgets/load/prs/${this.slug}`)
            .subscribe((data: IWidgetData) => {
                this.data = data;
                this.isLoading = false;
            }, (error: HttpErrorResponse) => {
                this.notificationsService.error(composeMessage(error));
                console.error(error);
                this.isLoading = false;
            });
    }

}
